import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID } from 'utils/types';
import css from './CardTitle.css';
import StyledButton from 'common/StyledButton';

function CardTitle(props) {
  return (
    <div data-role="cardTitle" className={css['card-title']}>
      {props.studentId 
        ? (
          <StyledButton asLink onClick={props.openStudentFolder}>
            {props.name}
          </StyledButton>
        ) : <span>{props.name}</span>
      }
    </div>
  );
}

CardTitle.propTypes = {
  name: PropTypes.string.isRequired,
  studentId: SFEntityID,
  openStudentFolder: PropTypes.func.isRequired,
};

export default CardTitle;
